/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateFormulaContentDto
 */
export interface UpdateFormulaContentDto {
    /**
     * Material ID from materials table (UUID)
     * @type {string}
     * @memberof UpdateFormulaContentDto
     */
    materialId: string;
    /**
     * Weight/amount of this material in the formula
     * @type {number}
     * @memberof UpdateFormulaContentDto
     */
    weight: number;
}

/**
 * Check if a given object implements the UpdateFormulaContentDto interface.
 */
export function instanceOfUpdateFormulaContentDto(value: object): value is UpdateFormulaContentDto {
    if (!('materialId' in value) || value['materialId'] === undefined) return false;
    if (!('weight' in value) || value['weight'] === undefined) return false;
    return true;
}

export function UpdateFormulaContentDtoFromJSON(json: any): UpdateFormulaContentDto {
    return UpdateFormulaContentDtoFromJSONTyped(json, false);
}

export function UpdateFormulaContentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateFormulaContentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'materialId': json['materialId'],
        'weight': json['weight'],
    };
}

export function UpdateFormulaContentDtoToJSON(json: any): UpdateFormulaContentDto {
    return UpdateFormulaContentDtoToJSONTyped(json, false);
}

export function UpdateFormulaContentDtoToJSONTyped(value?: UpdateFormulaContentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'materialId': value['materialId'],
        'weight': value['weight'],
    };
}

